import React, { useEffect, useState } from 'react'
import close from '@/assets/images/close.svg'
import logo from '@/assets/images/logo.svg'
import burger from '@/assets/images/burger.svg'
import { BackButton } from '@/components/Button/BackButton'
import { MenuNavigation } from '@/components/MenuNavigation/MenuNavigation'

interface HeaderProps {
  title?: string
  onBackClick?: () => void
  showBtn?: boolean
  isLastQuestion?: boolean
  isLastStep?: boolean
  hideHeader?: boolean
  hideBtnHeader?: boolean
  hideBurger?: boolean
  hideBackHeader?: boolean
  hideNav?: boolean
  isPage?: boolean
  step?: number
  fixed?: boolean
}
export function Header(props: HeaderProps) {
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const [showOnLastQuesttion, setShowOnLastQuesttion] = useState(props.isLastQuestion)
  useEffect(() => {
    setShowOnLastQuesttion(false)
  }, [props.isLastQuestion])

  return (
    <>
      <div
        className={`${openMenu ? 'translate-x-0' : 'translate-x-full'}  fixed top-0 right-0 h-full w-full z-40 bg-white border border-gray transition-all duration-300 flex flex-col`}
      >
        <div className="px-4 py-2.5 flex items-center justify-between pl-6 relative">
          <div
            className="relative transition-all active:scale-95 cursor-pointer"
            onClick={() => setOpenMenu(false)}
          >
            <img className="w-full" width="40" height="40" src={close} alt="close" />
          </div>
          <div className="h-[17px] absolute top-5 left-1/2 -translate-x-1/2">
            <img className="w-full" width="85" height="17" src={logo} alt="logo" />
          </div>
        </div>
        {openMenu && <MenuNavigation onClose={() => setOpenMenu(false)} />}
      </div>
      <div
        className={`w-full ${props.fixed ? 'sticky top-0 left-0 -mt-4 pt-4 ' : ''} pb-5 relative z-20 transition-all ${props.hideNav ? '-translate-y-full opacity-0 h-0' : 'translate-y-0'}`}
      >
        <div className="w-full">
          <div className="flex justify-center items-center relative  min-h-6">
            <div
              className={`w-full ${props.showBtn && !props.hideBtnHeader && !props.hideBackHeader ? 'opacity-100 visible' : 'opacity-0  invisible'} cursor-pointer absolute top-1/2 left-0 -translate-y-1/2 transition-all duration-300 active:scale-95`}
              onClick={props.onBackClick}
            >
              <BackButton />
            </div>
            <h3
              className={`${
                !props.hideHeader && !showOnLastQuesttion
                  ? 'opacity-100 visible'
                  : 'opacity-0  invisible'
              } font-medium text-center font-outfit transition-all duration-300 text-base`}
            >
              {props.title}
            </h3>
            {!props.hideHeader && !props.hideBurger && (
              <div
                className={`${props.hideBtnHeader ? 'opacity-0 invisible' : 'opacity-100 visible'} transition-all duration-300 cursor-pointer absolute top-1/2 right-0 -translate-y-1/2 active:scale-95 burger`}
                onClick={() => setOpenMenu(!openMenu)}
              >
                <img src={burger} alt="burger" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
